import { paths } from "api/schema/api-schema";
import assert from "assert";
import { djangoClientQueryFactory } from "api/client/helpers/queryFactory";
import { SerializedSideEffects } from "pages/gdt/store/SideEffects";

const path =
  "/library/gdt_analysis_table/insert_data_table_rows/{id}/" satisfies keyof paths;
type AnalysisTableId = paths[typeof path]["patch"]["parameters"]["path"]["id"];

export const gdtAnalysisTableFillSources = djangoClientQueryFactory(
  {
    method: "patch",
    path,
  },
  {
    formatInput: (
      AnalysisTableId: AnalysisTableId,
      body: {
        data_table_rows?: string[];
        analysis_table_rows?: string[];
        side_effects: SerializedSideEffects;
      },
    ) => ({
      params: { path: { id: AnalysisTableId } },
      body: {
        ...body,
        data_table_rows: body.data_table_rows ?? [],
        analysis_table_rows: body.analysis_table_rows ?? [],
      },
    }),
    handleResponse: (res) => {
      const data = res.data;
      assert(data !== undefined, "Expected data to be defined in response");
      return data;
    },
  },
);
